import styled from 'styled-components';

import { NavBarwidth } from 'const';
import { pxToRem } from 'utils/scss';

import logo from '../../assets/img/logos/f-2-mes-logo.svg';

export const MenuContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: ${pxToRem(NavBarwidth)};
  padding: 0 ${pxToRem('20px')};
  background-color: ${props => props.theme.colors.transparent};
  height: 100%;

  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  z-index: 1;
  padding: ${pxToRem('16px')} 0;
  color: white;
  overflow-y: auto;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
`;
export const Logo = styled.span`
  background: url(${logo});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: ${pxToRem('73px')};
  margin-bottom: ${pxToRem('105px')};
  :hover {
    cursor: pointer;
  }
`;

export const PlaceholderCorporate = styled.div`
  margin: 0 auto;
  margin-bottom: ${pxToRem('92px')};
  background-color: #b8bfde;
  border-radius: 100%;
  width: ${pxToRem('60px')};
  min-height: ${pxToRem('60px')};
  height: ${pxToRem('60px')};
`;
export const MenuItemContainer = styled.div``;
export const MenuIcon = styled.span`
  font-size: ${pxToRem('25px')};
  margin-bottom: ${pxToRem('16px')};
`;

export const MenuItem = styled.div`
  position: relative;
  /* padding: ${pxToRem('20px')}; */

  cursor: pointer;

  ::first-letter {
    text-transform: uppercase;
  }

  :not(:last-child) {
    margin-bottom: ${pxToRem('56px')};
  }

  &.active::after {
    content: '';
    width: ${pxToRem('5px')};
    height: 100%;
    background-color: white;
    position: absolute;
    left: ${pxToRem('1px')};
    top: 0;
    border-radius: ${pxToRem('20px')};
  }

  a {
    color: currentColor;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
`;

export const SupportIcon = styled.div`
  color: currentColor;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;
